export const DEEP_LINK_TEXT_MAX_LENGTH = 256;

export const deepLinkRequirementsUrl =
    'https://support.singular.net/hc/en-us/articles/360031371451-Singular-Links-Prerequisites';

const HOURS_PER_DAY = 24;
const HOURS_BEFORE_DAY_TICKS = 48;
const DAY_TICK_OFFSET = 46;
const ATTRIBUTION_WINDOW_OPTION_COUNT = 137;
const SESSION_INTERVAL_OPTION_COUNT = 36;
const SESSION_INTERVAL_MINUTE_STEP_COUNT = 12;
const SECONDS_PER_HOUR = 3600;
const FIVE_MINUTES_IN_SECONDS = 300;

export const DEFAULT_REATTRIBUTION_WINDOW_HOURS = 168;
export const DEFAULT_SESSION_DEDUP_WINDOW_SECONDS = 0;

const buildAttributionWindowOptions = ({ allowZero = false } = {}) =>
    Array.from({ length: ATTRIBUTION_WINDOW_OPTION_COUNT }, (_, step) => {
        if (!allowZero && step === 0) {
            return { value: 1 };
        }

        if (step >= HOURS_BEFORE_DAY_TICKS) {
            return { value: (step - DAY_TICK_OFFSET) * HOURS_PER_DAY };
        }

        return { value: step };
    });

const buildSessionIntervalOptions = () =>
    Array.from({ length: SESSION_INTERVAL_OPTION_COUNT }, (_, step) => {
        if (step > SESSION_INTERVAL_MINUTE_STEP_COUNT) {
            return { value: (step - (SESSION_INTERVAL_MINUTE_STEP_COUNT - 1)) * SECONDS_PER_HOUR };
        }

        return { value: step * FIVE_MINUTES_IN_SECONDS };
    });

export const formatAttributionWindowValue = value => {
    if (value < HOURS_BEFORE_DAY_TICKS) {
        return `${Number(value)}h`;
    }

    return `${Number(value) / HOURS_PER_DAY}d`;
};

export const formatSessionIntervalValue = value => {
    if (Number(value) < SECONDS_PER_HOUR) {
        return `${Number(value / 60)}m`;
    }

    return `${Number(value) / SECONDS_PER_HOUR}h`;
};

export const ATTRIBUTION_WINDOW_OPTIONS = buildAttributionWindowOptions();
export const ATTRIBUTION_WINDOW_OPTIONS_WITH_ZERO = buildAttributionWindowOptions({ allowZero: true });
export const ATTRIBUTION_WINDOW_VISIBLE_TICKS = [2, 12, 24, 48, 53, 60, 76, 106, 136];
export const ATTRIBUTION_WINDOW_VISIBLE_TICKS_WITH_ZERO = [0, 6, 12, 24, 48, 53, 60, 76, 106, 136];
export const SESSION_INTERVAL_OPTIONS = buildSessionIntervalOptions();
export const SESSION_INTERVAL_VISIBLE_TICKS = [1, 3, 6, 13, 15, 19, 27, 35];
